import type { CoreElement } from '@tunasong/schemas'
import type { TunaEditor, TunaPlugin } from '../plugin-types.js'
import React from 'react'

const decorationPluginsCache = new WeakMap<TunaPlugin[], TunaPlugin[]>()

const getDecorationPlugins = (pluginList: TunaPlugin[]) => {
  let cached = decorationPluginsCache.get(pluginList)
  if (!cached) {
    cached = pluginList.filter(p => p.blockDecorations)
    decorationPluginsCache.set(pluginList, cached)
  }
  return cached
}

export const hasBlockDecorationPlugins = (editor: TunaEditor) =>
  getDecorationPlugins(editor.meta.pluginList).length > 0

export const renderBlockDecorations = (editor: TunaEditor, element: CoreElement) =>
  getDecorationPlugins(editor.meta.pluginList)
    .map(plugin => {
      const decoration = plugin.blockDecorations?.(editor, element)
      return decoration ? <React.Fragment key={plugin.key}>{decoration}</React.Fragment> : null
    })
    .filter(Boolean)
